<div [class]="bubblePosition">
  <div class="testimonial-wrapper" >
    <div [class]="bubblePosition" [style.background-color]="color" class="cooper text-large center-children author-bubble">{{ capitalize(author.charAt(0))}}.</div>
    <div class="base-padding cooper" >{{ content }}.</div>
  </div>
</div>
